module.exports = __webpack_public_path__ + "static/popup-60bc62495f358ce541a61e644de8abdd.png";